import { render, staticRenderFns } from "./ServiceProposalList.vue?vue&type=template&id=7c715c52&"
import script from "./ServiceProposalList.vue?vue&type=script&lang=js&"
export * from "./ServiceProposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports